<template>
  <div class="snow">
    <div class="">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" class="text-center">
            <div
              class="text-uppercase display-2 pa-6 hidden-sm-and-down"
              style="color: #2E3440;"
            >
              Datenanalyse-Tool
            </div>
            <div
              class="text-uppercase display-1 pa-6 hidden-md-and-up"
              style="color: #2E3440;"
            >
              Datenanalyse-Tool
            </div>

            <v-divider
              style="border-color: #7d9b38; border-width: 5px; width:50%; display: inline-block; border-style: dotted none none none"
            ></v-divider>

            <p class="title font-weight-light pa-6">
              Sie möchten unsere Daten genauer analysieren? Dann können Sie hier
              Ihre eigenen Auswertungen machen. Wählen Sie zuerst im linken Feld
              aus verschiedenen Rubriken - von Chancen bis Social Media - die
              Variable aus, die Sie interessiert. Im rechten Feld können Sie
              unsere Daten dann anhand eines Filters, beispielsweise nach
              Bundesland oder Zweck, auswerten.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-container class="py-10" id="content">
      <v-row align="center">
        <v-col md="6" sm="6">
          <div
            v-intro="
              'Wählen Sie hier einen Themenbereich, der Sie interessiert. Hier sind alle Inhalte verfügbar, die im Rahmen der Studie erhoben wurden.'
            "
          >
            <v-select
              v-model="selectVariable"
              :items="topics"
              :menu-props="{ maxHeight: '400' }"
              item-text="name"
              item-value="name"
              label="Auswählen"
              hint="Variable"
              persistent-hint
              dense
              style="font-size: 14px !important"
            >
              <template slot="item" slot-scope="data">
                <template>
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="data.item.name"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
              </template>
            </v-select>
          </div>
        </v-col>
        <v-col md="6" sm="6">
          <div
            v-intro="
              'Wählen Sie hier einen Filter, der sich auf die befragen Organisationen bezieht. So können Sie unten die Ergebnisse nach ausgewähltem Thema und Filter vergleichen.'
            "
          >
            <v-row>
              <v-select
                v-model="selectFilter"
                :items="filterValues"
                @change="categoryLeft = categoryRight = 'Alle'"
                item-value="value"
                item-text="name"
                label="Auswählen"
                hint="Filter"
                persistent-hint
                dense
                style="font-size: 14px !important"
              ></v-select>
              <v-tooltip left v-if="selectFilter === 'financing'">
                <template v-slot:activator="{ on }">
                  <v-icon class="px-2" color="primary" dark large v-on="on"
                    >mdi-information</v-icon
                  >
                </template>
                <span dark>
                  <b>Erklärung der Kategorien</b>: <br />
                  NPO klassisch: Finanzierung durch Spenden und
                  Mitgliederbeiträge <br />

                  NPO hybrid: Finanzierung durch Spenden, Mitgliederbeiträge,
                  sowie anteilig durch Dienstleistungen <br />

                  NPO Social Business: Mehrheitliche Finanzierung durch
                  Dienstleistungen <br />
                </span>
              </v-tooltip>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" class="pa-6">
        <div
          v-intro="
            'Wählen Sie die Darstellungsart. Sie können wählen zwischen einem horizontalen und vertikalen Balkendiagrammen und einem Liniendiagramm.'
          "
        >
          <v-btn-toggle v-model="chartType" mandatory color="accent">
            <v-btn x-large>
              <v-icon large>mdi-poll</v-icon>
            </v-btn>
            <v-btn x-large>
              <v-icon large>mdi-chart-timeline-variant</v-icon>
            </v-btn>
            <v-btn x-large>
              <v-icon large style="transform: rotate(90deg)">mdi-poll</v-icon>
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-row>
      <v-container class="d-block pb-6">
        <v-row>
          <v-col cols="12" md="6" xl="6" sm="12">
            <div
              v-intro="
                'Hier sehen Sie die Ergebnisse für das gewünschte Thema und den gewählten Organisationsfilter. Sie können hier definieren, für welche Filtervariable Sie das Ergebnis sehen möchten (z.B. ein bestimmtes Bundesland). Weiterhin können Sie unter dem Diagramm auswählen, welche Fragen angezeigt werden sollen.'
              "
            >
              <v-card height="100%" class="d-flex flex-column pa-2" flat>
                <v-row>
                  <v-col>
                    <v-select
                      v-model="categoryLeft"
                      :items="Object.keys(filterData)"
                      label="Kategorie"
                      solo
                      dense
                      class="pa-2"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col :key="categoryLeft">
                    <highcharts
                      :options="leftChart"
                      ref="chartLeft"
                      :key="selectVariable"
                    ></highcharts>
                    <v-menu offset-x>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" aria-hidden="true">
                          <v-icon>mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="downloadLeft('image/jpeg')">
                          <v-list-item-content>
                            <v-list-item-title
                              >JPEG herunterladen</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="downloadLeft('image/svg+xml')">
                          <v-list-item-content>
                            <v-list-item-title
                              >SVG herunterladen</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                          href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
                          target="blank"
                        >
                          <v-list-item-content>
                            <v-list-item-title
                              class="pb-2"
                              style="color: #7D9B38"
                              >Lizenzbedingungen</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-col>
          <v-col cols="12" md="6" xl="6" sm="12">
            <div
              v-intro="
                'Hier können Sie die Ergebnisse links mit einem weiteren Filter vergleichen, z.B. das Ergebniss für ein Bundesland mit dem eines anderen.'
              "
            >
              <v-card height="100%" class="d-flex flex-column pa-2" flat>
                <v-row>
                  <v-col>
                    <v-select
                      v-model="categoryRight"
                      :items="Object.keys(filterData)"
                      label="Kategorie"
                      solo
                      dense
                      class="pa-2"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col :key="categoryRight">
                    <highcharts
                      :options="rightChart"
                      ref="chartRight"
                      :key="selectVariable"
                    ></highcharts>
                    <v-menu offset-x>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" aria-hidden="true">
                          <v-icon>mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="downloadRight('image/jpeg')">
                          <v-list-item-content>
                            <v-list-item-title
                              >JPEG herunterladen</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="downloadRight('image/svg+xml')">
                          <v-list-item-content>
                            <v-list-item-title
                              >SVG herunterladen</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                          href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
                          target="blank"
                        >
                          <v-list-item-content>
                            <v-list-item-title
                              class="pb-2"
                              style="color: #7D9B38"
                              >Lizenzbedingungen</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "intro.js/minified/introjs.min.css";
import "intro.js/themes/introjs-modern.css";

export default {
  name: "Comparison",
  data: () => ({
    discovery: true,
    selectVariable: "Strategie",
    selectFilter: "sector",
    chartType: 0,
    categoryLeft: "Alle",
    categoryRight: "Alle",
    pointSelected: { x: null, y: null },
    visibilityChartRight: [true, false, false, false],
    visibilityChartLeft: [],
    topics: [
      { header: "Chancen" },
      { name: "Zukunftstechnologien", group: "Chancen" },
      { name: "Zukunftstechnologien Nutzung", group: "Chancen" },
      { name: "Potenzial Cloud", group: "Chancen" },
      { name: "Anteil Cloud/On-Premise", group: "Chancen" },
      { name: "Cloud und Datenschutz", group: "Chancen" },
      { name: "Cloud Nutzen", group: "Chancen" },
      { divider: true },
      { header: "Herausforderungen" },
      { name: "Strategie", group: "Herausforderungen" },
      { name: "Lernorientierung", group: "Herausforderungen" },
      { name: "Zusammenarbeit", group: "Herausforderungen" },
      { name: "Innovationsfähigkeit", group: "Herausforderungen" },
      { name: "Digital Literacy", group: "Herausforderungen" },
      {
        name: "Digitalisierung als Herausforderung",
        group: "Herausforderungen"
      },
      { name: "konkrete Herausforderungen", group: "Herausforderungen" },
      { name: "Informationsbedarf", group: "Herausforderungen" },
      { name: "IT: Wissen und Ressourcen", group: "Herausforderungen" },
      { divider: true },
      { header: "IT Organisation" },
      { name: "IT Verantwortlichkeit", group: "IT Organisation" },
      { name: "Persönliche Einstellung zu IT", group: "IT Organisation" },
      { name: "Persönliche Fähigkeiten", group: "IT Organisation" },
      { name: "Technologieorientierung", group: "IT Organisation" },
      { name: "Nutzung IT", group: "IT Organisation" },
      { name: "Digitale Prozesse", group: "IT Organisation" },
      { divider: true },
      { header: "IT Infrastruktur" },
      { name: "Anti-Viren-Software", group: "IT Infrastruktur" },
      { name: "Anti-Viren-Software Anwendung", group: "IT Infrastruktur" },
      { name: "Fundraising-Software", group: "IT Infrastruktur" },
      { name: "CRM-Software", group: "IT Infrastruktur" },
      { name: "Online-Dienste", group: "IT Infrastruktur" },
      { name: "Website", group: "IT Infrastruktur" },
      { name: "Online-Spendenformular", group: "IT Infrastruktur" },
      { name: "Crowdfunding", group: "IT Infrastruktur" },
      { name: "Nutzung von Daten", group: "IT Infrastruktur" },
      { divider: true },
      { header: "IT Investitionen" },
      { name: "IT Prozesse & Weiterbildung", group: "IT Investitionen" },
      { name: "Qualifikation IT Verantwortliche", group: "IT Investitionen" },
      { name: "Erfahrung Verantwortliche IT", group: "IT Investitionen" },
      { name: "IT-Stellen", group: "IT Investitionen" },
      { name: "Externe Dienstleister", group: "IT Investitionen" },
      { name: "Aufgaben externe Dienstleister", group: "IT Investitionen" },
      { name: "Entwicklung IT-Budget", group: "IT Investitionen" },
      { name: "Investitionen Bereiche", group: "IT Investitionen" },
      { divider: true },
      { header: "Social Media" },
      { name: "Social Media Nutzung", group: "Social Media" },
      { name: "Social Media Kanäle", group: "Social Media" },
      { name: "Social Media Nutzen", group: "Social Media" },
      { name: "Social Media Häufigkeit Nutzung", group: "Social Media" },
      { name: "Social Media Content", group: "Social Media" }
    ]
  }),

  computed: {
    ...mapGetters("chartData", ["getSeries", "getLevels", "getTitle"]),
    chartTypeComputed() {
      switch (this.chartType) {
        case 1:
          return "line";
        case 2:
          return "bar";
        default:
          return "column";
      }
    },
    yAxisMax() {
      var v = [];
      var obLeft = this.filterData[this.categoryLeft];
      var obRight = this.filterData[this.categoryRight];
      obLeft.forEach(e =>
        v.push(Math.max(...e.data) / e.data.reduce((x, y) => x + y, 0))
      );
      obRight.forEach(e =>
        v.push(Math.max(...e.data) / e.data.reduce((x, y) => x + y, 0))
      );
      var global_max = Math.floor(Math.max(...v) * 100 + 5);

      return global_max;
    },
    questions() {
      return this.$store.getters["chartData/getData"];
    },
    filterValues() {
      return this.$store.getters["chartData/filterValues"];
    },
    filterData() {
      return this.getSeries({
        question: this.selectVariable,
        filter: this.selectFilter
      });
    },
    chartOptions() {
      return {
        chart: {
          height: "500",
          type: this.chartTypeComputed
        },
        plotOptions: {
          series: {
            point: {
              events: {
                mouseOver: e => {
                  e.preventDefault();
                  this.setPoint({ x: e.target.x, y: e.target.y });
                },
                mouseOut: e => {
                  e.preventDefault();
                  this.$refs.chartLeft.chart.tooltip.hide();
                  this.$refs.chartRight.chart.tooltip.hide();
                }
              }
            }
          }
        },
        title: {
          text: this.getTitle(this.selectVariable)
        },
        xAxis: {
          categories: this.getLevels(this.selectVariable),
          crosshair: false
        },
        yAxis: {
          min: 0,
          max: this.yAxisMax,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        legend: {
          enabled: true,
          itemStyle: {
            textOverflow: null
          }
        },
        tooltip: {
          formatter: function() {
            let index = this.point.x;
            let string = ``;

            if (Object.keys(this.series.chart.series).length > 1) {
              for (let series of this.series.chart.series) {
                if (series.visible) {
                  string += `<span><span style='color:${series.color} !important; padding:0'>${series.name}: </span>
            <b>${series.yData[index]}%</b></span><br />`;
                }
              }
            } else {
              let series = this.series.chart.series[0];
              string += `<span><span style='color:${series.color} !important; padding:0'></span>
            <b>${series.yData[index]}%</b></span><br />`;
            }

            return string;
          },
          useHTML: true
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500
              },
              // Make the labels less space demanding on mobile
              chartOptions: {
                chart: {
                  style: {
                    font:
                      "8px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
                  }
                },
                title: {
                  style: {
                    font:
                      "12px Galano, Roboto Black, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
                  }
                },
                subtitle: {
                  style: {
                    color: "#dddddd",
                    font:
                      "8px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif",
                    fontWeight: "light"
                  }
                },
                xAxis: {
                  labels: {
                    style: {
                      font:
                        "8px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
                    }
                  }
                },
                yAxis: {
                  labels: {
                    style: {
                      font:
                        "8px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
                    }
                  }
                },
                legend: {
                  itemMarginTop: 2,
                  itemStyle: {
                    font:
                      "10px Galano, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif"
                  }
                }
              }
            }
          ]
        },
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "analyse_tool",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff",
              size: "100%",
              events: {
                load: undefined
              }
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    },
    leftChart() {
      let chartOptions = {
        ...this.chartOptions,
        series: this.filterData[this.categoryLeft].map(series => {
          return {
            name: series.name,
            data: series.data.map(o =>
              Math.round((o / series.data.reduce((x, y) => x + y, 0)) * 100)
            )
          };
        })
      };
      chartOptions.chart.events = {};
      chartOptions.chart.events.load = e => {
        let l = e.target.series.length;
        for (let i = 0; i < l; i++) {
          e.target.series[i].setVisible(this.visibilityChartLeft[i]);
        }
      };
      chartOptions.plotOptions.series.events = {
        legendItemClick: e => {
          this.updateVisibilityLeft(e.target.index);
        }
      };
      return chartOptions;
    },

    rightChart() {
      let chartOptions = {
        ...this.chartOptions,
        series: this.filterData[this.categoryRight].map(series => {
          return {
            name: series.name,
            data: series.data.map(o =>
              Math.round((o / series.data.reduce((x, y) => x + y, 0)) * 100)
            )
          };
        })
      };
      chartOptions.chart.events = {};
      chartOptions.chart.events.load = e => {
        let l = e.target.series.length;
        for (let i = 0; i < l; i++) {
          e.target.series[i].setVisible(this.visibilityChartRight[i]);
        }
      };
      chartOptions.plotOptions.series.events = {
        legendItemClick: e => {
          this.updateVisibilityRight(e.target.index);
        }
      };
      return chartOptions;
    }
  },
  watch: {
    pointSelected(value) {
      this.$refs.chartLeft.chart.tooltip.refresh(
        this.$refs.chartLeft.chart.series[0].points[value.x]
      );
      this.$refs.chartRight.chart.tooltip.refresh(
        this.$refs.chartRight.chart.series[0].points[value.x]
      );
    },
    selectVariable() {
      this.visibilityChartRight = [true];
      for (let i = 1; i < this.$refs.chartRight.chart.series.length; i++) {
        this.visibilityChartRight.push(false);
      }
      this.visibilityChartLeft = [true];
      for (let i = 1; i < this.$refs.chartLeft.chart.series.length; i++) {
        this.visibilityChartLeft.push(false);
      }
    },
    discovery: {
      handler() {
        localStorage.setItem("discoveryStatus", this.discovery);
      }
    }
  },
  methods: {
    setPoint(pointSelected) {
      this.pointSelected = pointSelected;
    },
    updateVisibilityRight(i) {
      this.visibilityChartRight[i] = !this.visibilityChartRight[i];
    },
    getVisibilityRight() {
      let i = 0;
      let visArr = [];
      this.$refs.chartRight.chart.series.forEach(o => {
        if (i >= 0) visArr.push(o.visible);
        i++;
      });
      visArr[0] = this.$refs.chartRight.chart.series[0].visible;
      this.visibilityChartRight = visArr;
    },
    updateVisibilityLeft(i) {
      this.visibilityChartLeft[i] = !this.visibilityChartLeft[i];
    },
    getVisibilityLeft() {
      let i = 0;
      let visArr = [];
      this.$refs.chartLeft.chart.series.forEach(o => {
        if (i >= 0) visArr.push(o.visible);
        i++;
      });
      visArr[0] = this.$refs.chartLeft.chart.series[0].visible;
      this.visibilityChartLeft = visArr;
    },
    downloadRight(type) {
      this.$refs.chartRight.chart.exportChartLocal({
        type: type
      });
    },
    downloadLeft(type) {
      this.$refs.chartLeft.chart.exportChartLocal({
        type: type
      });
    }
  },
  mounted() {
    if (this.discovery) {
      const introJS = require("intro.js");
      var intro = introJS.introJs();
      intro.setOptions({ doneLabel: "Loslegen" });
      intro.setOptions({ nextLabel: "Nächster Tipp" });
      intro.setOptions({ prevLabel: "Zurück" });
      intro.setOptions({ skipLabel: "Überspringen" });
      intro.setOptions({ overlayOpacity: 0.5 });
      intro.setOptions({ keyboardNavigation: true });
      intro.start();
      this.discovery = false;
    }
  },
  created() {
    if (this.$route.query.var) {
      if (Object.keys(this.questions).includes(this.$route.query.var))
        this.selectVariable = this.$route.query.var;
      else this.selectVariable = "Strategie";
    }

    if (localStorage.getItem("discoveryStatus"))
      this.discovery = JSON.parse(localStorage.getItem("discoveryStatus"));
  }
};
</script>

<style scoped>
.snow {
  background-color: #f5f5f5;
}
</style>

<style>
.introjs-helperNumberLayer {
  position: absolute;

  z-index: 9999999999 !important;
  padding: 10px;
  font-size: 13px;
  top: -40px;
  font-family: "Galano";
  font-weight: 600;
  font-size: 16px;
  color: white;
  text-align: center;
  background: #f06914 !important;
  width: 20px;
  height: 20px;
  line-height: 20px;
}

.introjs-tooltip {
  background-color: #fff;
  color: #2e3440;
}

.active {
  background: #f06914 !important;
}
.introjs-tooltiptext {
  font-family: "Galano";
}

.introjs-button {
  color: #2e3440;
  font-size: 0.9rem;
}

.introjs-button:hover,
.introjs-button:focus {
  background-color: #f06914;
  color: #fff;
  outline: none;
  border-radius: 2px;
}

/** */

.introjs-button,
.introjs-button:hover,
.introjs-button:focus,
.introjs-button:active,
.introjs-disabled,
.introjs-disabled:focus,
.introjs-disabled:hover {
  outline: none;
  background-image: none;
  background-color: transparent;
  color: #2e3440;
  font-size: 12px;
  border: 1px solid transparent;
  border-radius: 20px;
  box-shadow: none;
  text-shadow: none;
  font-family: "Galano";
  font-weight: 300;
}

.introjs-button:hover,
.introjs-button:focus,
.introjs-button:active {
  border: 1px solid #2e3440;
}
.introjs-disabled,
.introjs-disabled:focus,
.introjs-disabled:hover {
  color: #2e3440;
  border: 1px solid transparent;
}

.introjs-arrow {
  border: 10px solid #fff;
}
.introjs-arrow.top,
.introjs-arrow.top-middle,
.introjs-arrow.top-right {
  border-color: transparent transparent rgba(000, 0, 0, 0.5);
  top: -20px;
  left: 20px;
}
.introjs-arrow.bottom,
.introjs-arrow.bottom-middle,
.introjs-arrow.bottom-right {
  border-color: rgba(000, 0, 0, 0.5) transparent transparent;
  bottom: -20px;
  left: 20px;
}
.introjs-arrow.left,
.introjs-arrow.right {
  top: 20px;
}
.introjs-arrow.left-bottom,
.introjs-arrow.right-bottom {
  bottom: 20px;
}

.introjs-arrow.left,
.introjs-arrow.left-bottom {
  left: -20px;
  border-color: transparent rgba(000, 0, 0, 0.5) transparent transparent;
}
.introjs-arrow.right,
.introjs-arrow.right-bottom {
  right: -20px;
  border-color: transparent transparent transparent rgba(000, 0, 0, 0.5);
}
</style>
